/*
  ATAO-207 crownat: header scroll state (client-approved option A).
  On the brand top the header is fixed and transparent over the hero;
  body.crownat-scrolled switches it to the opaque white state once the
  page is scrolled. --crownat-announce-offset keeps the fixed header below
  the announcement bar (if enabled) while the bar is still in view.
  Loaded only on crownat pages (theme.liquid).
*/
(function () {
  var THRESHOLD = 40;
  var ticking = false;
  var announcement = document.getElementById('shopify-section-announcement-bar');

  function update() {
    document.body.classList.toggle('crownat-scrolled', window.scrollY > THRESHOLD);

    if (announcement) {
      var offset = Math.max(0, announcement.getBoundingClientRect().bottom);
      document.body.style.setProperty('--crownat-announce-offset', offset + 'px');
    }
  }

  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      update();
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);

  update();
})();
